// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { pluralize } from '@/utilities/pluralize';
import { DateTime } from 'luxon';

/**
 * Formats an inclusive calendar date range duration.
 */
export function formatCalendarDateRangeDuration(
  startDate: DateTime | null | undefined,
  endDate: DateTime | null | undefined
): string | null {
  if (!startDate?.isValid || !endDate?.isValid) return null;

  const start = startDate.startOf('day');
  const end = endDate.startOf('day');
  if (end < start) return null;

  const diff = end.plus({ days: 1 }).diff(start, ['years', 'months', 'days']);
  const years = Math.floor(diff.years);
  const months = Math.floor(diff.months);
  const days = Math.floor(diff.days);

  const parts: string[] = [];
  if (years > 0) parts.push(pluralize(years, { singular: 'year' }));
  if (months > 0) parts.push(pluralize(months, { singular: 'month' }));
  if (days > 0) parts.push(pluralize(days, { singular: 'day' }));

  return parts.length > 0 ? parts.join(', ') : null;
}
